<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
@import "./assets/all";
#app {
  overflow-x: hidden;
  font-family: "Microsoft JhengHei";
}
</style>

<script>
console.log(
  "\n%c\u1d21\u1d07\u0299 \u0493\u0280\u1d0f\u0274\u1d1b-\u1d07\u0274\u1d05 \u1d05\u1d07\u1d20\u1d07\u029f\u1d0f\u1d18\u1d07\u0280  \u25c8  \u1d05\u1d07\u1d20\u1d07\u029f\u1d0f\u1d18\u1d07\u1d05 \u0299\u028f \u029f\u1d07\u026a\u1d00 \u029cs\u1d1c %c\n%c  %c \u273f \u273f  \u1d04\u1d0f\u1d05\u026a\u0274\u0262\u1d21\u026a\u0493\u1d07.\u1d04\u1d0f\u1d0d *\uff65\uff9f\u2727     %c  \u25b6 https://codingwife.com/   \u2764  ",
  "padding:10px 0;",
  "background: #577baa; padding:5px 0;",
  "background: #577baa; padding:5px 0;",
  "color: #cddded; background: #151b47; padding:5px 0;margin-bottom:20px;",
  "color:#FFF;background: #577baa; padding:5px 0;"
);
</script>